import { useEffect, useState } from "react";
import { Box, Button, Grid, Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchForms,
  createForm,
  updateForm,
  cloneForm,
  publishForm,
  removeForm
} from "../../store/dynamicForms";

import DynamicTable from "../../components/Table/DynamicTable";
import { clipboard_active_icon, clone_active_icon, clone_disabled_icon, create_acitve_icon, create_disabled_icon, dashboard_active_icon, dashboard_default_icon, delete_active_icon, delete_disabled_icon, edit_active_icon, edit_disabled_icon, review_disabled_icon, review_icon, trigger_icon, users_default_icon } from "../../constants/icons";
import Loader from "../../components/Loader/Loader";
import NoDataAvailable from "../../components/NoDataAvailable/NoDataAvailable";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import FormInputModal from "../../components/DynamicFormModal/DynamicFormModal";
import FormBuilder from "./FormBuilder/FormBuilder";
import TriggerTable from "./FormBuilder/FormTriggers/TriggerTable";
import FormResponse from "./FormResponse/FormResponse";
import UserTableAvatar from "../../components/UserTableAvatar/UserTableAvatar";
import { font_13, ROLE_TYPES } from "../../utils/utils";
import FormFill from "./FormFill/FormFill";
import { getFormInputList } from "../../store/formbuilderSlice";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import IconButtons from "../../components/IconButtons/IconButtons";
import SimpleModal from "../../components/Table/SimpleModal";
import { closeDashboard, openDashboard } from "../../store/dashboard";
import { useNavigate } from "react-router-dom";
import PerformanceDashboard from "../Dashboard/PerformanceDashboard";
import { use } from "react";

const DynamicFormsListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formsState = useSelector((state) => state.forms) || { items: [], loading: false };
  const { list: forms, loading } = formsState;
  const typeOptions = useSelector(
    (state) => state?.utility?.constants?.formType
  );
  const security = useSelector((state) => state?.security);
  const { fields, loading: previewLoading } = useSelector((state) => state.formBuilder);
  const roles = security?.roles;
  const loggedInUser = security?.loggedInUser;
  const isSPOC = loggedInUser?.permission?.spoc === true;

  const [openModal, setOpenModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [offset, setOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [finalFormList, setFinalFormList] = useState();
  const [deletedFormId, setDeletedFormId] = useState();
  const [isClone, setIsClone] = useState(false);
  const [canCloneForm, setCanCloneForm] = useState(true);
  const [canCreateInput, setCanCreateInput] = useState(true)
  const [isFormInputopen, setIsFormInputopen] = useState(false);
  const [formTriggerOpen, setFormTriggerOpen] = useState(false);
  const [triggerformData, setTriggerformData] = useState(null);
  const [isResponseViewOpen, setIsResponseViewOpen] = useState(false);
  const [selectedResponseForm, setSelectedResponseForm] = useState(null);
  const [formType, setFormType] = useState('');
  const [selectedTriggerId, setSelectedTriggerId] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFormFields, setPreviewFormFields] = useState([]);
  const [previewUserDetails, setPreviewUserDetails] = useState({});

  const [textModalOpen, setTextModalOpen] = useState(false);
  const [textModalData, setTextModalData] = useState("");
  const [dashboardOpen, setDashboardOpen] = useState(false);
  const [preselectedBootcampId, setpreselectedBootcampId] = useState(null)


  const isHR = ROLE_TYPES.isHr(roles);
  const isCompetencySpoc = ROLE_TYPES.isCompetencySpoc(roles)

  const refreshFormList = () => {
    dispatch(fetchForms({ offset: offset }));
  };

  const columns = [
    { key: "name", label: "Name" },
    {
      key: "type",
      label: "Type",
      render: (type) => {
        const typeLabel =
          typeOptions?.find((opt) => opt.key === type)?.value ?? "-";

        return (
          <Typography variant="font_12">
            {typeLabel}
          </Typography>
        );
      },
    },
    {
      key: "associatedBootcamps",
      label: "Associated Bootcamps",
      render: (bootcamps) => (
        <ExpandableBootcampList bootcamps={bootcamps} />
      ),
    },
    {
      key: "published",
      label: "Published?",
      align: "center",
      render: (value, row) => (
        <Switch
          disabled={getPermissions(row).publish}
          checked={!!value}
          onChange={() => dispatch(publishForm({ id: row.id, published: !row.published, data: row, offset: offset }))}
          size="small"
          sx={{
            margin: "0 0.5rem",
            "& .MuiSwitch-thumb": { width: 11, height: 11 },
          }}
        />
      ),
    },
    {
      key: "allowResponseModify",
      label: "Allow Response Modify?",
      align: "center",
      render: (value, row) => (
        <Switch
          disabled={getPermissions(row).allowResponseModify}
          checked={!!value}
          onChange={() => {
            dispatch(updateForm({
              formId: row.id,
              allowResponseModify: !value,
              published: row.published,
              enableViewForMentee: row.enableViewForMentee,
              offset: offset
            }));
          }}
          size="small"
          sx={{
            margin: "0 0.5rem",
            "& .MuiSwitch-thumb": { width: 11, height: 11 },
          }}
        />
      ),
    },
    {
      key: "enableViewForMentee",
      label: "Ratings Visible to Mentees",
      align: "center",
      render: (value, row) => (
        <Switch
          disabled={getPermissions(row).enableViewForMentee}
          checked={!!value}
          onChange={() => {
            dispatch(updateForm({
              formId: row.id,
              allowResponseModify: row.allowResponseModify,
              published: row.published,
              enableViewForMentee: !value,
              offset: offset
            }));
          }}
          size="small"
          sx={{
            margin: "0 0.5rem",
            "& .MuiSwitch-thumb": { width: 11, height: 11 },
          }}
        />
      ),
    },
    {
      key: "responseStats",
      label: "Responses",
      render: (value, row) => {
        if (!value || typeof value !== "object") return "-";
        const { response = 0, total = 0 } = value;

        return (
          <Typography
            variant="font_12"
            onClick={() => handleFormResponse(row)}
            sx={{
              cursor: "pointer",
              color: "#de1186",
              fontWeight: "bold",
              textDecoration: "underline",
              "&:hover": { color: "#de1186" },
            }}
          >
            {`${response}/${total}`}
          </Typography>
        );
      },
    },
    {
      key: "createdBy",
      label: "Created By",
      render: (value) => {
        if (!value) return "-";
        return (
          <UserTableAvatar
            imgAlt={value.name}
            imgSrc={value.avatar}
            href={value.id}
            label={value.name}
            subLabel={value.email}
            deleted={value.deleted}
          />
        );
      },
    }

  ]


  const actions = [
    {
      icon: edit_active_icon,
      tooltip: "Edit",
      onClick: (row) => handleEdit(row, "edit"),
      disabled: (row) => getPermissions(row).edit,
      disabledImage: edit_disabled_icon,
      disabledTooltip: "You don't have permission to edit",
      hideForSPOC: true,
    },
    {
      icon: clipboard_active_icon,
      tooltip: "View Description",
      onClick: (row) => handleTextModalOpen(row.description),
      disabled: (row) => getPermissions(row).description,
      disabledImage: clipboard_active_icon,
      disabledTooltip: "You don't have permission to view description",
      hideForSPOC: false,
    },
    {
      icon: delete_active_icon,
      tooltip: "Delete",
      onClick: (row) => handleDeleteModalOpen(row.id),
      disabled: (row) => getPermissions(row).delete,
      disabledImage: delete_disabled_icon,
      disabledTooltip: "You can't delete this form",
      hideForSPOC: true,
    },
    {
      icon: clone_active_icon,
      tooltip: "Clone",
      onClick: (row) => handleEdit(row, "clone"),
      disabled: (row) => getPermissions(row).clone,
      disabledImage: clone_disabled_icon,
      disabledTooltip: "You don't have permission to clone",
      hideForSPOC: true,
    },

    {
      icon: create_acitve_icon,
      tooltip: "Fields",
      onClick: (row) => handleFormInput(row),
      disabled: (row) => getPermissions(row).createInput,
      disabledImage: create_disabled_icon,
      disabledTooltip: "You don't have permission to create",
      hideForSPOC: false,
    },
    {
      icon: trigger_icon,
      tooltip: "Schedules",
      onClick: (row) => handleFormTrigger(row),
      disabled: !canCreateInput,
      disabledImage: clone_disabled_icon,
      disabledTooltip: !canCreateInput ? "You don't have permission to create" : null,
      hideForSPOC: false,
    },
    {
      icon: review_icon,
      tooltip: "Preview",
      onClick: (row) => handleFormPreview(row),
      disabled: (row) => getPermissions(row).previewForm,
      disabledImage: review_disabled_icon,
      disabledTooltip: "You don't have permission to preview",
      hideForSPOC: true,
    },
    {
      icon: dashboard_active_icon,
      tooltip: "dashboard",
      onClick: (row) => handleDashboardOpen(row),
      disabled: (row) => getPermissions(row).viewDashboard,
      disabledImage: dashboard_default_icon,
      disabledTooltip: "You don't have permission to view Dashboard",
      hideForSPOC: true,
    },
  ].filter(action => !(isSPOC && action.hideForSPOC));


  useEffect(() => {
    dispatch(fetchForms({ offset: offset }));
  }, [dispatch, offset]);

  useEffect(() => {
    if (forms.results?.length) {
      const formattedFormData = forms.results.map((item) => ({
        id: item?.id,
        name: item?.label || "",
        type: item?.type || "",
        description: item?.description || "",
        published: Boolean(item?.published),
        allowResponseModify: Boolean(item?.allowResponseModify),
        enableViewForMentee:Boolean(item?.enableViewForMentee),
        responseStats: { "response": item.filledResponses.totalResults, "total": item.totalResponses.totalResults },
        createdBy: {
          id: item?.createdBy?.employeeCode,
          name: item?.createdBy?.fullName || "",
          avatar: item?.createdBy?.profilePictureUrl || "",
          email: item?.createdBy?.email || "",
          deleted: item?.createdBy?.deleted || false
        },
        associatedBootcamps:
          item?.associatedBootcamps?.results?.map((b) => ({
            id: b?.id,
            name: b?.name,
            startDate: b?.startDate,
          })) || [],
        status: item?.published ? "Active" : "Inactive",
      }));
      setFinalFormList(formattedFormData);
    }
  }, [forms])
  useEffect(() => {
    setTotalPages(Math.ceil(forms.totalResults / 20));
  }, [forms.totalResults]);
  useEffect(() => {
    if (fields && fields.length > 0) {
      const formattedData = fields.map((el) => ({ input: el }));
      setPreviewFormFields(formattedData);
    }
  }, [fields]);
  const getPermissions = (row) => {
    const responseCount = row?.responseStats?.total;
    const isDisabled = responseCount >= 1;
    return {
      edit: !isHR || (isHR && isDisabled),
      delete: !isHR,
      clone: !isHR,
      description: !(isHR || isCompetencySpoc),
      createInput: false,
      publish: !isHR || (isHR && isDisabled),
      allowResponseModify: !row.published || isSPOC,
      enableViewForMentee: !isHR,
      previewForm: !isHR,
      viewDashboard: !isHR
    };
  };


  const handleCreate = () => {
    setIsClone(false);
    setEditData(null);
    setOpenModal(true);
  };

  const handleEdit = (row, type = '') => {
    if (type == 'clone') {
      setIsClone(true);
    } else {
      setIsClone(false);
    }
    setEditData(row);
    setOpenModal(true);
  };

  const handleDelete = () => {
    dispatch(removeForm(deletedFormId));
    setDeleteModalOpen(false);
    setCurrentPage(1);
    setOffset(0);
  };

  const handleDeleteModalOpen = (id) => {
    setDeletedFormId(id);
    setDeleteModalOpen(true)
  }

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditData(null);
  };

  const handleFormInput = (row) => {
    setEditData(row);
    setIsFormInputopen(true);
  }

  const handleFormTrigger = (row) => {
    setFormTriggerOpen(true);
    setTriggerformData(row)
  }

  const handleFormResponse = (row) => {
    setSelectedResponseForm(row);
    setIsResponseViewOpen(true);
    setFormType(row.type)
  }

  const handleTriggerResponseView = (triggerId) => {
    setSelectedTriggerId(triggerId);
    setFormTriggerOpen(false);
    setSelectedResponseForm(triggerformData);
    setFormType(triggerformData?.type);
    setIsResponseViewOpen(true);
  };


  const handleSubmitForm = (formData) => {
    if (!formData || typeof formData !== "object") {
      console.warn("Invalid form data provided.");
      return;
    }
    const {
      name = "",
      description = "",
      type = "",
      published = false,
      associatedBootcamps = [],
      formId,
    } = formData;
    const payload = {
      label: name.trim(),
      description: description.trim(),
      type,
      published: Boolean(published),
      bootcampIds: Array.isArray(associatedBootcamps)
        ? associatedBootcamps.map(({ id }) => id).filter(Boolean)
        : [],
    };
    const isEdit = Boolean(editData);
    const isFormClone = Boolean(isClone);
    let actionCreator = createForm;
    if (isEdit) {
      actionCreator = isFormClone ? cloneForm : updateForm;
      payload.allowResponseModify = editData.allowResponseModify;
    }

    if (formId && (isEdit || isFormClone)) {
      payload.formId = formId;
    }
    try {
      if (isEdit) {
        payload.offset = offset;
      }
      dispatch(actionCreator(payload));
      handleCloseModal();
      if (!isEdit) {
        setCurrentPage(1);
        setOffset(0);
      }
    } catch (error) {
      console.error("Error while submitting form:", error);
    }
  };


  const handlePageChange = (value) => {
    setCurrentPage(value);
    setOffset(value - 1);
  };

  const handleFormPreview = (row) => {
    setPreviewUserDetails({
      fullName: row.name,
      bootcamp: row.associatedBootcamps?.[0]?.name || "N/A",
      type: row.type,
      description:row.description
    });
    dispatch(getFormInputList(row.id));
    setPreviewOpen(true);
  };
  const handleDashboardOpen = (row) => {
    const bootcampIds = row.associatedBootcamps?.length
      ? row.associatedBootcamps.map(el => el.id)
      : [];
    dispatch(openDashboard({ bootcampId: bootcampIds }));
    setpreselectedBootcampId(bootcampIds)
    setDashboardOpen(true);
  }
  const handleCloseDashboard = () => {
    dispatch(closeDashboard())
    setDashboardOpen(false);
  }
  const closePreview = () => {
    setPreviewOpen(false);
    setPreviewFormFields([]);
  };
  const handleTextModalOpen = (content) => {
    setTextModalData(content);
    setTextModalOpen(true);
  };
  const handleTextModalClose = () => {
    setTextModalOpen(false);
    setTextModalData("");
  };
  if (dashboardOpen) {
    return (<PerformanceDashboard preselectedBootcampId={preselectedBootcampId} isClose={handleCloseDashboard} />)
  }

  return (
    <>
      {previewLoading && <Loader />}
      {loading && <Loader />}
      {isResponseViewOpen ? (<Box sx={{ p: 3 }}><FormResponse selectedResponseForm={selectedResponseForm} formType={formType} selectedTriggerId={selectedTriggerId}
        onBack={() => {
          setIsResponseViewOpen(false);
          setSelectedTriggerId(null);
        }}
      /> </Box>) : isFormInputopen ? <FormBuilder formData={editData} onCloseFormInput={() => setIsFormInputopen(false)} isSPOC={isSPOC} /> :
        <Box sx={{ p: 3 }}>
          <Grid container className="main-container">
            <Grid
              item
              className="header-container"
              md={12}
              sx={{
                height: "auto !important",
                minHeight: "unset"
              }}
            >
              <Box display="flex" flexDirection="column" sx={{ textAlign: 'left' }}>
                <Typography variant="font_21_bold">Performance Feedbacks</Typography>
                <Box display="flex" alignItems="center" gap={0.5} sx={{ mt: 0.5, opacity: 0.9 }}>
                  <InfoOutlinedIcon sx={{ fontSize: '1rem', color: '#de1186' }} />
                  <Typography variant="font_12" sx={{ color: "#4b4b4b", fontStyle: "italic" }}>
                    Responses will be generated and shared with users only after the form is published. Once shared, no further changes to the form are allowed.
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={0.5} sx={{ mt: 0.5, opacity: 0.9 }}>
                  <InfoOutlinedIcon sx={{ fontSize: '1rem', color: '#de1186' }} />
                  <Typography variant="font_12" sx={{ color: "#4b4b4b", fontStyle: "italic" }}>
                    For Dashboards to work, form needs to have AVERAGE_SCORE input added.
                  </Typography>
                </Box>
              </Box>
              {!isSPOC && (
                <Box className="header-right-icons create-from-actions">
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                      height: "1.875rem", "&.Mui-disabled .MuiTypography-root": {
                        color: "rgba(0, 0, 0, 0.26)",
                      },
                    }}
                    onClick={handleCreate}
                    disabled={!isHR}
                  >
                    <Typography color="secondary" variant="outlineBtnLabel">
                      Create Form
                    </Typography>
                  </Button>
                </Box>
              )}
            </Grid>

            <Grid item md={12} className="body-container">
              <Grid container className="table-parent-container">
                <Paper
                  elevation={0}
                  className="flex-container-column topic-paper-container"
                >
                  {!forms?.totalResults ? (
                    <Grid container className="no-data-container">
                      <NoDataAvailable
                        imgHeight={4}
                        imgWidth={4.5}
                        message="No Forms Available"
                      />
                    </Grid>
                  ) : (
                    forms?.results && <DynamicTable
                      title="Forms"
                      columns={columns}
                      rows={finalFormList}
                      totalResult={forms.totalResults}
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                      actions={actions}
                      loading={loading}
                    />
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Grid>
          {openModal && (<FormInputModal
            open={openModal}
            handleClose={handleCloseModal}
            initialData={editData}
            onSubmit={handleSubmitForm}
            isClone={isClone}
          />)}
          {deleteModalOpen && (
            <DeleteModal
              open={deleteModalOpen}
              handleClose={handleDeleteModalClose}
              handleDelete={handleDelete}
            />)}
          {formTriggerOpen && (
            <TriggerTable
              handleClose={() => setFormTriggerOpen(false)}
              open={formTriggerOpen}
              formId={triggerformData?.id}
              triggerformData={triggerformData}
              isSPOC={isSPOC}
              onTriggerActionSuccess={refreshFormList}
              onViewResponses={handleTriggerResponseView}
            />)
          }
        </Box>}

      {previewOpen && (
        <FormFill
          open={previewOpen}
          formFields={previewFormFields}
          selectedFormType={previewUserDetails.type}
          readOnly={true}
          userDetails={previewUserDetails}
          onSubmit={() => { }}
          handleClose={() => closePreview()}
        />
      )}

      <SimpleModal
        open={textModalOpen}
        handleClose={handleTextModalClose}
        data={textModalData}
        message="No Description Available"
        isAgenda={false}
      />

    </>
  );
};

export default DynamicFormsListing;

const ExpandableBootcampList = ({ bootcamps }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const INITIAL_LIMIT = 3;

  if (!bootcamps || bootcamps.length === 0) return "-";

  const hasMore = bootcamps.length > INITIAL_LIMIT;
  const visibleBootcamps = isExpanded ? bootcamps : bootcamps.slice(0, INITIAL_LIMIT);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}>
      {visibleBootcamps.map((bootcamp) => (
        <Typography
          key={bootcamp.id}
          variant="font_12"
          sx={{ borderRadius: "0.4rem", width: "fit-content" }}
        >
          {bootcamp.name}
        </Typography>
      ))}

      {hasMore && (
        <Typography
          variant="font_9_bold"
          color="secondary"
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            cursor: "pointer",
            mt: 0.5,
            fontWeight: 600,
            textDecoration: 'underline',
            '&:hover': { opacity: 0.8 }
          }}
        >
          {isExpanded ? "VIEW LESS" : `VIEW MORE`}
        </Typography>
      )}
    </Box>
  );
};
